import { docStateLabel } from "@capture/shared";
import type { ReconciledTotals } from "../hooks/useQueues";

interface ReconciledSummaryBarProps {
  reconciled: ReconciledTotals | null;
}

// F-030/F-031 item 5 — roll-up labels single-sourced through the canonical
// `docStateLabel` (lowercased for the inline "{N} label" format) so the bar and
// the batch badge can never drift from the 4-state vocabulary.
const SEGMENTS: { key: keyof ReconciledTotals["byState"]; tone: string }[] = [
  { key: "ready", tone: "ready" },
  { key: "busy", tone: "busy" },
  { key: "error", tone: "error" },
  { key: "complete", tone: "complete" },
];

export function ReconciledSummaryBar({ reconciled }: ReconciledSummaryBarProps) {
  if (!reconciled) return null;
  return (
    <div className="queue-reconciled" data-testid="reconciled-bar" role="status" aria-live="polite">
      <span className="queue-reconciled-live">
        <strong data-testid="reconciled-live">{reconciled.live}</strong> live
      </span>
      {SEGMENTS.map((seg) => (
        <span
          key={seg.key}
          className={`queue-reconciled-seg queue-reconciled-seg--${seg.tone}`}
          data-testid={`reconciled-${seg.key}`}
        >
          {reconciled.byState[seg.key]} {docStateLabel(seg.key).toLowerCase()}
        </span>
      ))}
    </div>
  );
}
